export default "__VITE_ASSET__CwIJQ0a9__"